/* eslint-disable @typescript-eslint/no-unused-vars */
'use client'


import React, { useEffect, useState } from 'react';
import AppBar from '@mui/material/AppBar';
import Slide from '@mui/material/Slide';
import { useTranslations } from 'next-intl';
import useMediaQuery from '@mui/material/useMediaQuery';
import Link from 'next/link';
import dynamic from 'next/dynamic';

import '@/components/styles/header.css';
import Cookies from "js-cookie";
import {Rfs__all} from "../../../../_refs/Rfs__all";

const MenuBar = dynamic(() => import('./menu-bar/menu-bar'), { ssr: false });
const Image = dynamic(() => import('@/components/common/image'), { ssr: false });
const LinksCard = dynamic(() => import('./links-card/inks-card'), { ssr: false });

const Header: React.FC = () => {
    const [show, setShow] = useState(true);
    const [lang, setLang] = React.useState('en');
    const [lastScrollY, setLastScrollY] = useState(0);
    const t = useTranslations('header');
    const is_mobile = useMediaQuery('(max-width:1024px)');

    useEffect(()=>{
      const lang = Cookies.get('language') || 'en';
      setLang(lang);
    })

    useEffect(() => {
        const handleScroll = () => {
            const currentScrollY = window.scrollY;

            if (currentScrollY > lastScrollY && currentScrollY > 50) {
                setShow(false);
            }
            else {
                setShow(true);
            }

            setLastScrollY(currentScrollY);
        };

        window.addEventListener('scroll', handleScroll);
        return () => window.removeEventListener('scroll', handleScroll);
    }, [lastScrollY]);

    Rfs__all.header_Section();

    return (
        <>
            <Slide className="__Header_Slide__" direction="down" in={show}>
                <AppBar className="__Header_AppBar__" position="fixed" elevation={0}>
                  {
                    lang == 'fa' ?
                      <div
                        role="heading"
                        aria-level={1}
                        className={`Header_Div`}
                      >
                        <div className={`Header_Div_right`}>
                          <Link href={'/home'} className='lnk_logo mr-auto lg:mr-0'>
                              <Image url='/logo.svg' alt='logo' className='lg:w-48 w-[100px]'/>
                          </Link>
                          {!is_mobile &&
                            <MenuBar />
                          }
                        </div>
                        <LinksCard/>
                      </div>
                      :
                      <div
                        role="heading"
                        aria-level={1}
                        className={`flex flex-row items-center overflow-hidden pt-10 lg:px-20 px-4 z-50 bg-mainBackground lg:h-[109px]`}
                      >
                        <Link
                          href={'/home'}
                          className='Img_logo mr-auto lg:mr-0'
                        >
                          <Image
                            url='/logo.svg'
                            alt='logo'
                            className='lg:w-48 w-[100px]'
                          />
                        </Link>
                        {!is_mobile &&
                          <MenuBar />
                        }
                        <LinksCard />
                      </div>
                  }
                </AppBar >
            </Slide >
            <div className={'__div_end_header__'} />
        </>
    );
};

export default Header;
